import React from "react";
import { ShareButton } from "../../atoms/form/button/share";
import { FaTelegramPlane } from "react-icons/fa";
import { trackClipSocialShare, trackCreatorCardShare } from "./utils";
import styled from "styled-components";

const StyledShare = styled(FaTelegramPlane)`
  color: #f8fcfd;
`;

export default function TelegramShare({ link, clip, card, ...props }) {
  return (
    <>
      <ShareButton
        title="Share to Telegram"
        justifyContent={"center"}
        alignItems="center"
        flex={true}
        display="flex"
        href={`https://t.me/share/url?url=${link}&text=${props.title}`}
        target="_blank"
        onClick={() => {
          if (clip) {
            trackClipSocialShare({
              platform: "Telegram",
              isMontage: clip.isMontage,
              clip,
            });
          } else if (card) {
            trackCreatorCardShare(card);
          }
        }}
        {...props}
      >
        <StyledShare size={24}></StyledShare>

        {props.children}
      </ShareButton>
    </>
  );
}
